import {
    NavLink, Outlet, Link, useNavigate,
} from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import { useState } from 'react';
import Menu from 'react-burger-menu/lib/menus/slide';
import 'react-burger-menu';
import Logo from './static/images/logo.png';
import Footer from './components/Footer';
import './App.css';
import isAdmin from './service/adminAuth';

const hrStyle = {
    border: '0px',
    borderTop: '1px solid white',
    height: '1px',
};

function App() {
    const navigate = useNavigate();
    const { isAuthenticated, logout, user } = useAuth0();
    const schoolVerified = sessionStorage.getItem('schoolPasswordVerified') === 'true';
    const hasAdminAccess = isAuthenticated && isAdmin(user);

    // controls if hamburger menu should be open/close
    const [isOpen, setOpen] = useState(false);

    // toggles between true/false
    const handleIsOpen = () => {
        setOpen(!isOpen);
    };

    // sets state to false; closes menu
    const closeSideBar = () => {
        setOpen(false);
    };

    const handleMembersClick = (e) => {
        if (!isAuthenticated && !schoolVerified) {
            // prevent navigation if not authenticated and no school session
            e.preventDefault();
            navigate('/verify-access-code');
        } else {
            navigate('/members');
        }
        closeSideBar();
    };

    const handleLogout = () => {
        if (isAuthenticated) {
            logout({ logoutParams: { returnTo: window.location.origin } });
        } else if (schoolVerified) {
            sessionStorage.removeItem('schoolPasswordVerified');
            window.location.href = '/';
        }
    };

    return (
        <div className="app-container">
            <main className="content">
                {/* Hamburger menu */}
                <Menu
                    isOpen={isOpen}
                    onOpen={handleIsOpen}
                    onClose={handleIsOpen}
                    right>
                    <NavLink
                        onClick={closeSideBar}
                        to="/">
                        HOME
                    </NavLink>
                    <hr style={hrStyle} />
                    <NavLink
                        onClick={closeSideBar}
                        to="/mission">
                        OUR MISSION
                    </NavLink>
                    <hr style={hrStyle} />
                    <NavLink
                        onClick={closeSideBar}
                        to="/about">
                        ABOUT US
                    </NavLink>
                    <hr style={hrStyle} />
                    <NavLink
                        onClick={closeSideBar}
                        to="/samples">
                        SAMPLE LESSONS
                    </NavLink>
                    <hr style={hrStyle} />
                    <NavLink
                        onClick={handleMembersClick}
                        to="/members">
                        {isAuthenticated || schoolVerified ? 'MEMBERS' : 'MEMBERS LOGIN'}
                    </NavLink>
                    <hr style={hrStyle} />
                    <NavLink
                        onClick={closeSideBar}
                        to="/contact">
                        CONTACT US
                    </NavLink>
                    {hasAdminAccess && <hr style={hrStyle} />}
                    {hasAdminAccess && <NavLink onClick={closeSideBar} to="/admin">ADMIN</NavLink>}
                    <hr style={isAuthenticated || schoolVerified ? hrStyle : { display: 'none' }} />
                    <NavLink
                        style={isAuthenticated || schoolVerified ? {} : { display: 'none' }}
                        onClick={handleLogout}
                        to="/contact">
                        LOG OUT
                    </NavLink>
                </Menu>

                {/* Main nav menu split into two rows */}
                <div className="navigation">
                    <div className="nav-header-row">
                        <div className="logo-left">
                            <Link to="/">
                                <img
                                    src={Logo}
                                    alt="Logo" />
                            </Link>
                        </div>
                        <div className="contact-us">
                            {hasAdminAccess && (
                                <NavLink
                                    className="button-contact-us admin-header-link"
                                    to="/admin">
                                    ADMIN
                                </NavLink>
                            )}
                            {(isAuthenticated || schoolVerified) && (
                                <button type="button" className="button-contact-us" onClick={handleLogout}>
                                    LOG OUT
                                </button>
                            )}
                        </div>
                    </div>
                    <nav className="nav-list nav-menu-row">
                        <ul>
                            <li className="nav-button">
                                <NavLink
                                    to="/"
                                    activeclassname="underline">
                                    HOME
                                </NavLink>
                            </li>
                            <li className="nav-button">
                                <NavLink
                                    to="/mission"
                                    activeclassname="underline">
                                    OUR MISSION
                                </NavLink>
                            </li>
                            <li className="nav-button">
                                <NavLink
                                    to="/about"
                                    activeclassname="underline">
                                    ABOUT US
                                </NavLink>
                            </li>
                            <li className="nav-button">
                                <NavLink
                                    to="/samples"
                                    activeclassname="underline">
                                    SAMPLE LESSONS
                                </NavLink>
                            </li>
                            <li className={`nav-button${['/members', '/verify-access-code'].includes(window.location.pathname) ? ' active' : ''}`}>
                                <NavLink
                                    to="/members"
                                    activeclassname="underline"
                                    className={({ isActive }) => (isActive || window.location.pathname === '/verify-access-code' ? 'active' : '')}>
                                    {isAuthenticated || schoolVerified ? 'MEMBERS' : 'MEMBERS LOGIN'}
                                </NavLink>
                            </li>
                        </ul>
                    </nav>
                </div>
                <Outlet />
            </main>
            <footer className="footer">
                <Footer />
            </footer>
        </div>
    );
}

export default App;
